import { prefetchModelShow } from '@rhino-project/core/hooks';
import { NotFoundPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';
import PlayerPage from '../../../../pages/players/PlayerPage';

export const Route = createFileRoute('/_authenticated/$owner/players/$id/')({
  loader: ({ context: { rhino }, params: { id } }) => {
    return prefetchModelShow(rhino, 'player', id);
  },
  component: RouteComponent,
  notFoundComponent: NotFoundPage
});

function RouteComponent() {
  return <PlayerPage />;
}
